import axios from 'axios';

const baseUrl = id => `/api/v1/comment/${id}/`;

export function like(id) {
  return axios.post(`${baseUrl(id)}/_like`);
}

export function unlike(id) {
  return axios.post(`${baseUrl(id)}/_unlike`);
}
